import React from 'react';
import Rutas from './components/Rutas';
import ScrollToTop from './components/ScrollToTop';
import useGlitchText from './hooks/useGlitchText';
import useMouseSpotlight from './hooks/useMouseSpotlight';
import './config/i18n'; // Importar configuración de i18n

import WhatsAppButton from './components/WhatsAppButton';

function App() {
  // Initialize glitch text translations
  useGlitchText();

  // Initialize mouse spotlight effect for all cards
  useMouseSpotlight();

  return (
    <div className="App">
      <Rutas />
      <ScrollToTop />
      <WhatsAppButton />
    </div>
  );
}

export default App;
